import React from 'react';
import {useEnvironment} from '@wix/yoshi-flow-editor';
import {classes, st} from './LineItemSection.st.css';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../Widget/ControllerContext';
import {LineItemRow} from '../LineItem/LineItem';

export enum LineItemSectionDataHooks {
  root = 'LineItemSectionDataHooks.root',
  list = 'LineItemSectionDataHooks.list',
}

export const LineItemSection = () => {
  const localeKeys = useLocaleKeys();
  const {isMobile} = useEnvironment();
  const {
    checkoutStore: {cart},
  } = useControllerProps();

  return (
    <div data-hook={LineItemSectionDataHooks.root}>
      <ul
        data-hook={LineItemSectionDataHooks.list}
        className={st(classes.itemsList, isMobile ? classes.itemsListMobile : undefined)}
        aria-label={localeKeys.checkout.orderSummary.fullSection.ariaLabel()}>
        {cart.lineItems &&
          cart.lineItems.map((lineItem) => (
            <LineItemRow lineItem={lineItem} key={lineItem.id} useLayoutForLongPrice={cart.hasItemsWithLongPrice} />
          ))}
      </ul>
    </div>
  );
};
